import { HttpServiceBase } from "../../../common-services/Http/HttpServiceBase";
import { Result } from "../../../common-models/Result";
import { GetErpNfInput } from "./GetErpNfInput";
import { GetErpNfOutput } from "./GetErpNfOutput";

export class GetErpNfService extends HttpServiceBase {

  handle = (input: GetErpNfInput): Promise<Result<GetErpNfOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<GetErpNfOutput>>(`${this.baseUrlSislogApi}/v2/erp-integration/nf${parameters}`);
    return promise;
  }
}